// extracted by mini-css-extract-plugin
module.exports = {"container":"_40d5d0e87d--container--v8Wme","logo":"_40d5d0e87d--logo--TN8gi","description":"_40d5d0e87d--description--XHYiD"};